import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, onMounted, watch, computed } from "vue";
import { ClassifierQuestion, ClassifierQuestionType } from "../model";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassifierQuestionField',
  props: {
    question: null,
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  question: ClassifierQuestion,
  modelValue: string[],
}



const selectedSingleOption = ref<string|null>(null);
const selectedMultipleOptions = ref<string[]>([]);
const otherText = ref<string>("");

onMounted(() => {
  // Parse and initialize based on initial model value
  switch (props.question.type) {
    case ClassifierQuestionType.CHOOSE_ONE: {
      selectedSingleOption.value = props.modelValue.length == 0 ? null : decodeOption(props.modelValue[0]);
      break;
    }

    case ClassifierQuestionType.CHOOSE_MULTI: {      
      selectedMultipleOptions.value = props.modelValue.map(s => decodeOption(s));
      break;
    }
  }
});



const onChange = () => {
  if (props.question.type == ClassifierQuestionType.CHOOSE_ONE) {
    emit('update:modelValue', selectedSingleOption.value == null ? [] : [encodeOption(selectedSingleOption.value)]);
  } else {
    emit('update:modelValue', selectedMultipleOptions.value.map(s => encodeOption(s)));
  }
};

const encodeOption = (val: string) => {
  return val == "Other" ? `Other:${otherText.value}` : val;
}

const decodeOption = (val: string) => {
  if (val.startsWith("Other:")) {
    otherText.value = val.substring("Other:".length);
    return "Other";
  } else {
    return val;
  }
}

watch(selectedSingleOption, ()=>{
  onChange();  
});

watch(selectedMultipleOptions, ()=>{
  onChange();
});

watch(otherText, ()=>{
  onChange();
});

const availableAnswers = computed(() => {
  const answers:any = {};
  for (let a of props.question.answers) {
    answers[a.label] = a.id;
  }
  if (props.question.includeOtherOption) {
    answers[props.question.otherOptionLabel || "Other"] = "Other";
  }
  return answers;
})

return (_ctx: any,_cache: any) => {
  const _component_FormTextField = _resolveComponent("FormTextField")!
  const _component_FormRadioGroupField = _resolveComponent("FormRadioGroupField")!
  const _component_FormCheckboxGroupField = _resolveComponent("FormCheckboxGroupField")!

  return (__props.question.type == _unref(ClassifierQuestionType).CHOOSE_ONE)
    ? (_openBlock(), _createBlock(_component_FormRadioGroupField, {
        key: 0,
        label: __props.question.prompt,
        options: _unref(availableAnswers),
        modelValue: selectedSingleOption.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSingleOption).value = $event)),
        stacked: ""
      }, {
        default: _withCtx(() => [
          (selectedSingleOption.value == 'Other')
            ? (_openBlock(), _createBlock(_component_FormTextField, {
                key: 0,
                modelValue: otherText.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otherText).value = $event)),
                autoFocus: "",
                class: "pt-0"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label", "options", "modelValue"]))
    : (__props.question.type == _unref(ClassifierQuestionType).CHOOSE_MULTI)
      ? (_openBlock(), _createBlock(_component_FormCheckboxGroupField, {
          key: 1,
          label: __props.question.prompt,
          options: _unref(availableAnswers),
          modelValue: selectedMultipleOptions.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedMultipleOptions).value = $event)),
          stacked: ""
        }, {
          default: _withCtx(() => [
            (selectedMultipleOptions.value?.includes('Other'))
              ? (_openBlock(), _createBlock(_component_FormTextField, {
                  key: 0,
                  modelValue: otherText.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((otherText).value = $event)),
                  autoFocus: "",
                  trimmed: "",
                  class: "pt-0"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label", "options", "modelValue"]))
      : _createCommentVNode("", true)
}
}

})